var _path, _path2, _path3, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChosenExercises(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Zapisane_zadania_-_ikona",
    "data-name": "Zapisane zadania - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.5,
    height: 35,
    viewBox: "0 0 27.5 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Elipse_gray",
    "data-name": "Elipse gray",
    d: "M390.253,18h0a6.253,6.253,0,0,1,6.252,6.252h0a6.253,6.253,0,0,1-6.252,6.252h0A6.253,6.253,0,0,1,384,24.252h0A6.253,6.253,0,0,1,390.253,18Z",
    transform: "translate(-369.005 -18)",
    fill: "#e6e6e6",
    opacity: 0.001,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_blue",
    "data-name": "Elipse blue",
    d: "M390.253,18h0a6.253,6.253,0,0,1,6.252,6.252h0a6.253,6.253,0,0,1-6.252,6.252h0A6.253,6.253,0,0,1,384,24.252h0A6.253,6.253,0,0,1,390.253,18Z",
    transform: "translate(-369.005 -18)",
    fill: "#464af0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M393.836,24.293h-2.293V22h-1.25v2.293H388v1.25h2.293v2.293h1.25V25.543h2.293Z",
    transform: "translate(-369.67 -18.665)",
    className: "inverted",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M386.008,33.057V51.5H368.5v-25h10.946V24H366V54h22.509V33.058Z",
    transform: "translate(-366 -18.998)",
    fill: "#464af0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1766",
    "data-name": "Rectangle 1766",
    width: 12.505,
    height: 2.501,
    transform: "translate(4.998 12.914)",
    fill: "#464af0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1767",
    "data-name": "Rectangle 1767",
    width: 12.505,
    height: 2.501,
    transform: "translate(4.998 18.75)",
    fill: "#464af0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1768",
    "data-name": "Rectangle 1768",
    width: 12.505,
    height: 2.501,
    transform: "translate(4.998 24.585)",
    fill: "#464af0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChosenExercises);
export default __webpack_public_path__ + "static/media/chosen_exercises.8ee726adbc3c5d2cb5071374a68da665.svg";
export { ForwardRef as ReactComponent };